import { useNavigate } from "react-router-dom";
import type { PersonSummary } from "@shared/types";

interface PeopleTableProps {
  people: PersonSummary[];
  busyId: string | null;
  onConnect: (person: PersonSummary) => void;
  emptyMessage?: string;
}

/** Org-wide directory list — modeled on DocumentsTable.tsx's list/table pattern. */
export function PeopleTable({ people, busyId, onConnect, emptyMessage }: PeopleTableProps) {
  const navigate = useNavigate();

  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Title</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {people.map((person) => (
            <tr key={person.id}>
              <td>
                <button className="link-btn" onClick={() => navigate(`/network/${person.id}`)}>
                  {person.fullName ?? person.email}
                </button>
              </td>
              <td className="doc-type">{person.role.replace(/_/g, " ")}</td>
              <td className="muted">{person.title ?? "—"}</td>
              <td className="doc-actions">
                {person.relation === "none" && (
                  <button className="btn btn-primary" disabled={busyId === person.id} onClick={() => onConnect(person)}>
                    {busyId === person.id ? "Sending…" : "Connect"}
                  </button>
                )}
                {person.relation === "pending_sent" && <span className="status-chip status-draft">Pending</span>}
                {person.relation === "pending_received" && <span className="status-chip status-draft">Wants to connect</span>}
                {person.relation === "connected" && <span className="status-chip status-approved">Connected</span>}
              </td>
            </tr>
          ))}
          {people.length === 0 && (
            <tr>
              <td colSpan={4} className="muted">
                {emptyMessage ?? "No one found."}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
